var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedSurvey)?_c('div',[_c('breadcrumb'),_c('show',{attrs:{"survey":_vm.selectedSurvey}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }